import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownButton } from "react-bootstrap";

import { NewVideoPlayer } from "../../MainEvents/RecommendEventVideos/styles";
import Thumbnail from "../../Thumbnail";
import { ImageUrl } from "../../../utils/constants";
import { RelatedCard, RelatedCardContainer } from "../../VideoArticle/styles";

import {
  VerticalDotsIcon,
  PdfIcon,
  JpgIcon,
  PngIcon,
  DocumentIcon,
  Eyeicon,
  SheetIcon,
  FallbackRewardDocIcon
} from "../../../utils/icons";

import { DownAngleV2 } from "../../SocialFeedsV2/styles";

import styled from "styled-components";

export const DetailsContainer = styled.div`
  ${'' /* padding: 12px 14px; */}
  width:100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top:14px;
`;

export const Title = styled.div`
  font-weight: 700;
  color: #184A61;
  font-family: Lato;
  font-size: 16px;
  line-height: 20px;
  white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;

`;

export const DownloadsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  color: #184A61;
  font-family: Lato;
  font-size: 14px;
`;

export const BottomRow = styled(Row)`
  margin-top: 8px;
`;

export const LastUpdated = styled.div`
color: #989898;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;

gap:9px;

display:flex;
align-items:center;
`;


const DocumentsGridCard = ({
  document,
  onEdit,
  onDownload,
  onDelete
}) => {

  const [onHover, setOnHover] = useState(-1);

  const onEnterMouse = (id) => {
    setOnHover(id);
  };

  const onLeaveMouse = () => {
    setOnHover(-1);
  };

  // const getFileIcon = (ext = "") => {
  //   const extension = ext.toLowerCase();

  //   switch (extension) {
  //   case "pdf":
  //     return <PdfIcon width={'24px'} height={'24px'}/>;
  //   case "jpeg":
  //     return <JpgIcon width={'24px'} height={'24px'}/>;
  //   case "png":
  //     return <PngIcon width={'24px'} height={'24px'}/>;
  //   default:
  //     return <DocumentIcon width={'24px'} height={'24px'}/>; // fallback
  //   }
  // };

  const getFileIcon = (ext = "") => {
    const extension = ext.toLowerCase();

    switch (extension) {
    case "pdf":
      return <PdfIcon width={'24px'} height={'24px'}/>;
    case "jpeg":
    case "jpg":
      return <JpgIcon width={'24px'} height={'24px'}/>;
    case "png":
      return <PngIcon width={'24px'} height={'24px'}/>;
    case 'csv':
    case "xls":
    case "xlsx":
      return <SheetIcon width={'24px'} height={'24px'}/>;
    case 'doc':
    case "docx":
      return <DocumentIcon width={'24px'} height={'24px'}/>;
    default:
      return <FallbackRewardDocIcon width={'24px'} height={'24px'}/>; // fallback
    }
  };

  return (
    <RelatedCardContainer margin={'0px 20px 20px 0px'} >
      <RelatedCard
        onMouseEnter={() => onEnterMouse(document.id)}
        onMouseLeave={onLeaveMouse}
      >
        {/* Thumbnail */}
        <NewVideoPlayer height={"218px"}>
          <Thumbnail
            style={{ cursor: "default" }}
            src={`${ImageUrl}/${document?.document_image}`}
            alt={"doc"}
            height={"218px"}
          />
        </NewVideoPlayer>

        {/* Hover overlay */}
        {onHover === document.id && (
          <div className="educateImageBackground">
            <div
              className="getStarted"
              onClick={() => onDownload(document)}
            >
              Download
            </div>
          </div>
        )}

        {/* Details */}
        <DetailsContainer>

          <Row>
            <Title title={document?.title}>
              {document?.title}
            </Title>

            <DownloadsContainer>
              {Eyeicon()}
              {document?.downloads}
            </DownloadsContainer>
          </Row>

          <BottomRow>
            <LastUpdated>
              <div>{getFileIcon(document?.extension)}</div> <div>Last Updated: {document?.last_updated}</div>
            </LastUpdated>

            <div className="menu">
              <DownAngleV2 feed padding="0 8px" marginL="-120px">
                <DropdownButton
                  id={`doc-${document.id}`}
                  title={<VerticalDotsIcon height={'18px'}/>}
                >
                  <Dropdown.Item onClick={() => onEdit(document)}>
                    Edit
                  </Dropdown.Item>

                  <Dropdown.Item onClick={() => onDownload(document)}>
                    Download
                  </Dropdown.Item>

                  <Dropdown.Item onClick={() => onDelete(document)}>
                    Delete
                  </Dropdown.Item>
                </DropdownButton>
              </DownAngleV2>
            </div>

          </BottomRow>

        </DetailsContainer>
      </RelatedCard>
    </RelatedCardContainer>
  );
};

DocumentsGridCard.propTypes = {
  document: PropTypes.object,
  margin: PropTypes.string,
  onEdit: PropTypes.func,
  onDownload: PropTypes.func,
  onDelete: PropTypes.func
};

export default DocumentsGridCard;
